import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = {
  class: "bg-gray-400 flex h-screen w-full fixed items-center justify-center",
  style: {'left': '0px'}
}
const _hoisted_2 = { class: "flex flex-col modal-box w-96" }
const _hoisted_3 = { class: "flex justify-end w-full" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 11L11 1",
    stroke: "#222B45",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 1L11 11",
    stroke: "#222B45",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "flex flex-col gap-4 p-2 w-full" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center w-full" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Change Phone Number")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text-center text-small" }, "After you change your Phone, next time you need to login with the new one. Phone number must be verified with OTP.", -1)
const _hoisted_9 = { class: "flex gap-2" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "flex justify-end" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "Update", -1)
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args))),
          class: "modal-button-close"
        }, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selected) = $event)),
            type: "text",
            class: "form-field phone-w"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
              return (_openBlock(), _createElementBlock("option", {
                key: option,
                value: option.id
              }, _toDisplayString(option.code), 9, _hoisted_10))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.selected]
          ]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.NewPhone) = $event)),
            type: "text",
            class: "form-field w-full"
          }, null, 512), [
            [_vModelText, _ctx.NewPhone]
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", {
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.updatePhone && _ctx.updatePhone(...args))),
            class: "button"
          }, _hoisted_13)
        ])
      ])
    ])
  ]))
}